import { useIsAuth } from "../../hooks/useIsAuth"
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/mainReducer";
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { FiTrash } from "react-icons/fi";
import { cadastroActions } from "../reducer";
import Layout from "../../sistema/components/Layout";
import { ListHeader } from "../../sistema/components/ListHeader";
import { DefaultButton } from "../../sistema/components/DefaultButton";
import Loader from "../../sistema/components/Loader";
import { ListInput } from "../../sistema/components/ListInput";
import ResponsiveTable, { TableHeaders } from "../../sistema/components/ResponsiveTable";
import { Pagination } from "../../sistema/components/Pagination";
import { ConfirmButton } from "../../sistema/components/ConfirmButton";
import { Lista } from "../types/lista";

export const ListaList = () => {
  useIsAuth();

  const listas = useSelector((state: RootState) => state.cadastro.listas);
  const isLoading = useSelector((state: RootState) => !!state.cadastro.isLoading);
  const success = useSelector((state: RootState) => !!state.cadastro.success);
  const dispatch = useDispatch()
  const [page, setPage] = useState(1);
  const [termo, setTermo] = useState("");

  useEffect(() => {
    dispatch(cadastroActions.listasRequest({
      page,
      termo,
    }))
  }, [dispatch, page, termo])

  useEffect(() => {
    if (!success) {
      return;
    }
    dispatch(cadastroActions.listasRequest({
      page,
      termo,
    }))
  }, [dispatch, success, page, termo])

  const headers: TableHeaders<Lista>[] = [
    {
      label: "Código",
      wrapped: true,
      render: (item) => item.codigo,
    },
    {
      label: "Descrição",
      wrapped: true,
      render: (item) => item.descricao,
    },
    {
      label: "Ações",
      wrapped: true,
      render: (item, index) => <>{<ConfirmButton confirm={() => onDeleteItem(item.id as number)}><FiTrash /></ConfirmButton>}</>,
      notClicable: true,
    },
  ];

  const onDeleteItem = (id: number) => {
    dispatch(cadastroActions.deleteListaRequest(id));
  }

  const navigate = useNavigate();

  return (
    <Layout>
      <ListHeader label={`Listas`}>
        <DefaultButton ml={4} to={`/listas/novo`}> Novo </DefaultButton>
      </ListHeader>

      <Loader isLoading={isLoading} />

      <ListInput label="Filtrar por codigo ou descrição" onSubmit={setTermo} />

      {listas && <ResponsiveTable isSmall onClick={(item: any) => navigate(`/listas/${item.item.id}`)} headers={headers} data={listas.data} />}

      {listas && <Pagination info={listas} paginate={setPage} />}
    </Layout>
  )
}